import db from "../db";
import Constants from "../constants";
import * as Helpers from "../helpers";
import Vuex from "vuex";

export default {
  data() {
    return {
      processing: false,
      offertaToConfirm: false,
      offertaInsufficiente: false,
      rilanciRelativi: [1, 5],
    };
  },
  methods: {
    showNumpad() {
      db.emit("numpad", true);
    },
    hideNumpad() {
      db.emit("numpad", false);
    },
    setPasso(confirm = false) {
      if (confirm) {
        Swal.fire({
          title: "Vuoi passare?",
          text: "Non potrai annullare l'operazione",
          icon: "warning",
          showCancelButton: true,
          confirmButtonText: "Si",
          cancelButtonText: "No",
        }).then((result) => {
          if (result.isConfirmed == true) {
            db.setOfferta(Constants.OFFERTA.PASSO, false, true);
          }
        });
      } else {
        db.setOfferta(Constants.OFFERTA.PASSO, false, true);
        Swal.close();
      }
    },
    setOffertaCustom(val) {
      this.dismissSelvaggiaAction && this.dismissSelvaggiaAction();
      this.setOfferta(val);
    },
    canRilanciareDi(incremento) {
      const squadra = this.squadra(this.user_uid);
      return !!squadra && Helpers.canOffrire(
        squadra,
        this.migliore_offerta.offerta + incremento
      );
    },
    preparaRilancio(incremento) {
      if (!this.canRilanciareDi(incremento)) return;
      this.offertaToConfirm = this.migliore_offerta.offerta + incremento;
      this.offertaInsufficiente = false;
    },
    confirmOfferta() {
      if (this.offertaToConfirm) {
        if (this.offertaToConfirm > this.migliore_offerta.offerta) {
          this.setOfferta(this.offertaToConfirm);
          this.offertaToConfirm = false;
          this.offertaInsufficiente = false;
        } else {
          this.offertaToConfirm = this.migliore_offerta.offerta + 1;
          this.offertaInsufficiente = true;
        }
      }
    },
    annullaOffertaToConfirm() {
      this.offertaToConfirm = false;
      this.offertaInsufficiente = false;
    },
    async setOfferta(val) {
      try {
        if (this.processing) return;
        this.processing = true;
        await db.setOfferta(val, false, true);
        this.processing = false;
      } catch (error) {
        this.processing = false;
        throw new Error(error);
      }
    },
  },
  computed: {
    canSelvaggiaAct() {
      return (
        this.canShowSelvaggiaHeaderStatus &&
        !this.selvaggiaTimeover &&
        !this.hoPassato
      );
    },
    canShowSelvaggiaHeaderStatus() {
      return (
        this.mode_selvaggia &&
        this.squadra(this.user_uid) &&
        this.squadra(this.user_uid).active &&
        this.calciatoreInAsta !== null &&
        this.calciatoreInAsta !== undefined &&
        this.running
      );
    },
    showSelvaggiaCannotRaise() {
      return (
        this.canShowSelvaggiaHeaderStatus &&
        !this.selvaggiaTimeover &&
        this.sonoVincitore &&
        this.creditiInsufficienti
      );
    },
    showSelvaggiaWaiting() {
      return (
        this.canShowSelvaggiaHeaderStatus &&
        !this.showSelvaggiaCannotRaise &&
        !this.canSelvaggiaAct
      );
    },
    selvaggiaCannotJoinReason() {
      if (
        !this.mode_selvaggia ||
        !this.asta_info ||
        !this.asta_info.lega ||
        !this.squadra(this.user_uid) ||
        this.calciatoreInAsta === null ||
        this.calciatoreInAsta === undefined
      ) {
        return null;
      }

      return Helpers.canJoinRoundWithReason(
        this.asta_info.lega,
        this.squadra(this.user_uid),
        this.calciatore(this.calciatoreInAsta),
        this.minOfferta
      ).reason;
    },
    selvaggiaPassoText() {
      return this.selvaggiaCannotJoinReason || "Hai passato";
    },
    showSelvaggiaPassoHint() {
      return (
        this.canShowSelvaggiaHeaderStatus &&
        this.hoPassato
      );
    },
    selvaggiaTimeover() {
      return (
        this.asta_selvaggia_time_left !== null &&
        this.asta_selvaggia_time_left !== undefined &&
        this.asta_selvaggia_time_left <= 0
      );
    },
    ruolo_abc() {
      if (this.calciatoreInAsta != null) {
        return Constants.RUOLI_NEW[
          this.calciatori[this.calciatoreInAsta].ID_Ruolo
        ].abc;
      }
      return null;
    },
    vincitore() {
      return this.migliore_offerta.vincitore;
    },
    offerta() {
      return this.migliore_offerta.offerta;
    },
    sonoVincitore() {
      return this.migliore_offerta.vincitore == this.user_uid;
    },
    hoPassato() {
      return (
        this.asta_round.offerte &&
        this.asta_round.offerte[this.user_uid] == Constants.OFFERTA.PASSO
      );
    },
    minOfferta() {
      return this.migliore_offerta.vincitore != null
        ? this.migliore_offerta.offerta + Constants.RILANCIO_MIN
        : Helpers.minOfferta(
            this.asta_settings.base_asta,
            this.calciatore(this.asta_round.calciatoreInAsta)
          );
    },
    creditiInsufficienti() {
      if (this.squadra(this.user_uid)) {
        return !Helpers.canOffrire(
          this.squadra(this.user_uid),
          this.minOfferta
        );
      }
      return true;
    },
    ...Vuex.mapGetters([
      "migliore_offerta",
      "myPlan",
      "asta_selvaggia_time_left",
    ]),
  },
};
